export const transcricoes = {
  list: '/v3/api/aawz-transcriptions/transcriptions',
  detail: (id) => `/v3/api/aawz-transcriptions/transcriptions/${id}`,
  update: (id) => `/v3/api/aawz-transcriptions/transcriptions/${id}`,
  regenerate: (id) =>
    `/v3/api/aawz-transcriptions/transcriptions/${id}/summary/regenerate`,
  // Listagem de clientes para o seletor de vínculo — usa o endpoint de sessão
  // do app (o /clients/all da extensão exige Bearer token).
  clientsList: '/v2/api/app/listar_clientes',
  // Listagem de projetos do escritório para o seletor de vínculo da transcrição.
  projectsList: '/v3/api/aawz-transcriptions/projects',
  // Detalhe/edição/remoção de um projeto (gestor). PUT/DELETE são owner-scoped no
  // backend (modelos globais de outro escritório → 404).
  projectDetail: (id) => `/v3/api/aawz-transcriptions/projects/${id}`,
  // Critérios de avaliação de um projeto: GET (lista) + POST (cria).
  projectCriterias: (id) =>
    `/v3/api/aawz-transcriptions/projects/${id}/criterias`,
  // Critério individual: PUT (atualiza) + DELETE (remove).
  projectCriteria: (pid, cid) =>
    `/v3/api/aawz-transcriptions/projects/${pid}/criterias/${cid}`,
  // Scores por critério de uma transcrição (aba Avaliação) — reuso do read da spec-001.
  scores: (id) => `/v3/api/aawz-transcriptions/transcripts/${id}/scores`,
  // Dashboard gestor-only de agregação de scores (spec-005) — média por projeto
  // + ranking de profissionais. Não-gestor → status 403 no body (HTTP 200).
  dashboard: '/v3/api/aawz-transcriptions/projects/dashboard',
  // Ficha do Cliente (IA): schema dos grupos/campos (1x por sessão, cacheado
  // no store), leitura e escrita dos valores extraídos pela IA.
  fichaSchema: '/v3/api/aawz-transcriptions/clients/ficha/schema',
  // GET (leitura) e PATCH (escrita) usam a MESMA rota — 2 chaves só pra
  // deixar explícito no call site (`con.get`/`con.patch`) qual verbo cada
  // uma serve; nunca deixe as 2 strings divergirem.
  ficha: (id) =>
    `/v3/api/aawz-transcriptions/clients/${encodeURIComponent(id)}/ficha`,
  fichaPatch: (id) =>
    `/v3/api/aawz-transcriptions/clients/${encodeURIComponent(id)}/ficha`,
  // Briefing do cliente: dossiê determinístico + pontos de conversa (IA
  // opcional). Sem ?ia=false — dossiê e pontos chegam juntos numa única
  // chamada (a IA tem timeout síncrono de até 45s no backend).
  briefing: (id) =>
    `/v3/api/aawz-transcriptions/clients/${encodeURIComponent(id)}/briefing`,
}

export const deviceTokens = {
  list: '/v3/api/aawz-transcriptions/device-tokens',
  create: '/v3/api/aawz-transcriptions/device-tokens',
  delete: (id) => `/v3/api/aawz-transcriptions/device-tokens/${id}`,
}

export const crm = {
  leads: (id) =>
    id ? `/v3/api/aawz-crm/crm-lead/${id}` : '/v3/api/aawz-crm/crm-lead',
  batchTemplate: (isLead) =>
    isLead
      ? '/v3/api/aawz-crm/crm-lead/import/template?filename=crm-leads-template&file_extension=xlsx'
      : '/v3/api/aawz-crm/app-clientes/import/template?filename=clientes-template&file_extension=xlsx',
  batchImport: (isLead) =>
    isLead
      ? '/v3/api/aawz-crm/crm-lead/import/read'
      : '/v3/api/aawz-crm/app-clientes/import/read',
  batchSave: (isLead) =>
    isLead
      ? '/v3/api/aawz-crm/crm-lead/import/save'
      : '/v3/api/aawz-crm/app-clientes/import/save',
  batchImportEdit: (isLead) =>
    isLead
      ? '/v3/api/aawz-crm/crm-lead/edit/read'
      : '/v3/api/aawz-crm/app-clientes/edit/read',
  batchSaveEdit: (isLead) =>
    isLead
      ? '/v3/api/aawz-crm/crm-lead/edit/save'
      : '/v3/api/aawz-crm/app-clientes/edit/save',
  exportData: (isLead, actualDate) =>
    isLead
      ? `/v3/api/aawz-crm/crm-lead/edit/export?filename=base-crm-leads-${actualDate}&file_extension=xlsx`
      : `/v3/api/aawz-crm/app-clientes/edit/export?filename=base-clientes-${actualDate}&file_extension=xlsx`,
  regua: '/v3/api/aawz-crm/crm-relacionamento-regua',
  reguaCompleto: '/v3/api/aawz-crm/crm-relacionamento-regua-completo',
  reguaAtividade: '/v3/api/aawz-crm/crm-relacionamento-regua-atividade',
  reguaCliente: '/v3/api/aawz-crm/crm-relacionamento-regua-cliente',
  reguaClienteSync: '/v3/api/aawz-crm/crm-relacionamento-regua/sync',
  // Adia/reagenda a próxima atividade de régua de relacionamento de um
  // cliente. Form fields: id (uuid do vínculo), data (YYYY-MM-DD), horario
  // (HH:mm, opcional — omitido quando vazio/falsy).
  reguaClienteDataPrevista:
    '/v3/api/aawz-crm/crm-relacionamento-regua-cliente/data-prevista',
  historicoAtividade: '/v3/api/aawz-crm/crm-historico-atividade-cliente',
  atividadesSugeridas:
    '/v3/api/aawz-crm/crm-atividades-sugeridas-automatizadas',
  clients: '/v3/api/aawz-crm/crm-relacionamento-clientes-overview',
  clientsTasks: '/v3/api/aawz-crm/crm-relacionamento-clientes-tasks',
  clientsKanban: '/v3/api/aawz-crm/crm-relacionamento-clientes-kanban',
  clientsFavorites: '/v3/api/aawz-crm/crm-favorito-profissional',
  leadsOverview: '/v3/api/aawz-crm/crm-leads-overview',
  overviewIndicators: '/v3/api/aawz-crm/crm-dashboard-overview',
  monthlyRoutine: '/v3/api/aawz-crm/crm-relacionamento-rotina-mensal-kanban',
  monthlyRoutineStage:
    '/v3/api/aawz-crm/crm-relacionamento-rotina-mensal-etapa',
  calendar: '/v3/api/aawz-crm/crm-calendar',
  calendarEditTime: '/v3/api/aawz-crm/crm-calendar/edit-time',
  calendarResolveConvidados: '/v3/api/aawz-crm/crm-calendar/resolve-convidados',
  // Sincroniza a agenda externa (Google/Microsoft) do profissional no espelho
  // local. POST body vazio; lock por profissional no backend.
  calendarSync: '/v3/api/aawz-crm/crm-calendar/sync',
  /**
   * @method GET
   */
  leadTimeline: (id) => `/v3/api/aawz-crm/crm-lead-timeline?id_lead=${id}`,
  /**
   * @method GET
   */
  clientTimeline: (id) =>
    `/v3/api/aawz-crm/crm-cliente-timeline?id_cliente_app=${id}`,
  /**
   * @method GET
   * Devolve { id_cliente_app, id_lead, status_lead } de um cliente — usado por
   * resolveClienteTarget para decidir o mode (lead/cliente) do modal cliente-360
   * ao entrar via navegação client-centric.
   */
  clienteLeadStatus: (id) =>
    `/v3/api/aawz-crm/crm-cliente-lead-status?id_cliente_app=${id}`,
  /**
   * @method GET
   */
  historicLead: (id) =>
    id
      ? `/v3/api/aawz-crm/crm-historico-atividade-lead/${id}`
      : `/v3/api/aawz-crm/crm-historico-atividade-lead`,
  // Desfaz a conclusão de uma atividade de funil (deleta a linha de histórico)
  historicLeadReverter: () =>
    `/v3/api/aawz-crm/crm-historico-atividade-lead/reverter-conclusao`,
  // Marca o lead como perdido com motivo (espelha oportunidadeFunil.desfecho).
  // O backend agenda data_retorno_funil_prevista quando o motivo tem
  // dias_retorno_funil > 0; a rotina diária promove o lead de volta ao funil.
  leadDesfecho: '/v3/api/aawz-crm/crm-lead-desfecho',
  // Ligações (API4Com) — listagem + vínculo inline
  ligacoes: '/v3/api/aawz-crm/crm-chamadas-telefonicas',
  ligacoesById: (id) => `/v3/api/aawz-crm/crm-chamadas-telefonicas/${id}`,
  // Sincronização de chamadas — POST dispara (assíncrona, lock por
  // profissional-alvo via ?id_profissional), GET retorna { em_execucao }
  // para polling do alvo correto.
  ligacoesSincronizar: '/v3/api/aawz-crm/crm-chamadas-telefonicas/sincronizar',
  // Token da integração API4Com (por profissional — cada um o seu token)
  api4comToken: '/v3/api/aawz-crm/chamadas-telefonicas/integracao/token',
  // Profissionais com token API4Com configurado — alimenta o select do gestor.
  api4comProfissionaisComToken:
    '/v3/api/aawz-crm/chamadas-telefonicas/integracao/profissionais-com-token',
  // Clientes acessíveis (escopo de permissão por sessão) — alimenta os selects
  // de vínculo/filtro de cliente da tela de Ligações.
  clientesApp: '/v2/api/app/listar_clientes',
}

export const crmClienteFoto = {
  /**
   * @method POST upload da foto do cliente (multipart, campo `foto`)
   * @method DELETE remove a foto do cliente
   */
  manage: (id_cliente) => `/v3/api/aawz-crm/app-clientes/${id_cliente}/foto`,
}

export const funil = {
  funis: (id) =>
    id
      ? `/v3/api/aawz-crm/crm-funil-vendas/${id}`
      : `/v3/api/aawz-crm/crm-funil-vendas`,
  steps: `/v3/api/aawz-crm/crm-funil-vendas-etapa`,
  stepsTasks: `/v3/api/aawz-crm/crm-funil-vendas-etapa-atividade`,
  stepComplete: `/v3/api/aawz-crm/crm-leads-kanban`,
  liberarCustomizacao: `/v3/api/aawz-crm/crm-copiar-funil-regua`,
  funilCompleto: `/v3/api/aawz-crm/crm-funil-vendas-completo`,
  /**
   * @method GET — config de campos obrigatórios por etapa (+ Ganho) do funil,
   * filtrada por `?id_funil_vendas=<uuid>`.
   * @method PUT — replace atômico da config (somente gestor); body =
   * { id_funil_vendas, etapas: [{id_funil_vendas_etapa, campos}], ganho: {campos} }
   */
  camposObrigatorios: `/v3/api/aawz-crm/crm-funil-vendas-etapa-campo-obrigatorio`,
}

// Grupo de oportunidade-funil (pipeline configurável de oportunidades).
// Espelha o grupo `funil` de leads, apontando para as rotas paralelas do
// backend (`/v3/api/aawz-crm/crm-oportunidade-funil*`).
export const oportunidadeFunil = {
  funis: (id) =>
    id
      ? `/v3/api/aawz-crm/crm-oportunidade-funil/${id}`
      : `/v3/api/aawz-crm/crm-oportunidade-funil`,
  steps: `/v3/api/aawz-crm/crm-oportunidade-funil-etapa`,
  stepsTasks: `/v3/api/aawz-crm/crm-oportunidade-funil-etapa-atividade`,
  realtime: `/v3/api/aawz-crm/crm-oportunidade-funil-realtime`,
  funilCompleto: `/v3/api/aawz-crm/crm-oportunidade-funil-completo`,
  mover: `/v3/api/aawz-crm/crm-oportunidade-mover`,
  desfecho: `/v3/api/aawz-crm/crm-oportunidade-desfecho`,
  /**
   * @method GET — linha do tempo (etapas + atividades materializadas) de uma
   * oportunidade. Espelha leadTimeline para o contexto de oportunidade.
   */
  oportunidadeTimeline: (id) =>
    `/v3/api/aawz-crm/crm-oportunidade-timeline/${id}`,
  /**
   * @method PUT — materializa (on-demand) a atividade-template da etapa em
   * pm_task e define seu status. Resolve o 404 do toggle quando a etapa entrou
   * via roteamento de criação (atividades ainda não materializadas).
   * body = { id_oportunidade, id_etapa, id_atividade (template), status }
   */
  oportunidadeAtividadeStatus:
    '/v3/api/aawz-crm/crm-oportunidade-atividade-status',
  motivoPerda: (id) =>
    id
      ? `/v3/api/aawz-crm/crm-oportunidade-motivo-perda/${id}`
      : `/v3/api/aawz-crm/crm-oportunidade-motivo-perda`,
}

export const origens = {
  base: `/v3/api/aawz-crm/crm-origem`,
  byId: (id) => `/v3/api/aawz-crm/crm-origem/${id}`,
  usage: (id) => `/v3/api/aawz-crm/crm-origem/${id}/usage`,
  naoRegistradas: `/v3/api/aawz-crm/crm-origem/nao-registradas`,
  registrarExistente: `/v3/api/aawz-crm/crm-origem/registrar-existente`,
}

export const KYC = {
  /**
   * @method POST
   * @param {Object} data ex. {
    "id_cliente_app": 11954,
    "cpf": "38244335831",
    "advanced": true
    }
   */
  add: `/v2/api/kyc`,
  /**
   * @method GET
   */
  get: (id_cliente_app, advanced) =>
    `/v2/api/kyc?id_cliente_app=${id_cliente_app}&advanced=${advanced}`,
  /**
   *  @method GET
   */
  list: `/v2/api/kyc/list`,
  /**
   * @method PUT/POST
   */
  update: (id) => (id ? `/v2/api/kyc/update/${id}` : '/v2/api/kyc/update'),
}

export const financialPlanning = {
  /**
   * @method GET
   */
  bens: (idClienteApp) =>
    `/v3/api/aawz-financial-planning/clients/${idClienteApp}/patrimony`,
  /**
   * @method GET - Patrimônio consolidado (bens + investimentos)
   */
  patrimonyConsolidated: (idClienteApp) =>
    `/v3/api/aawz-financial-planning/clients/${idClienteApp}/patrimony-consolidated`,
}

export const empresas = {
  manage: '/v3/api/aawz-crm/crm-empresas',
  empresaCliente: (id_cliente_app) =>
    id_cliente_app
      ? `/v3/api/aawz-crm/clientes/${id_cliente_app}/crm-empresas`
      : '/v3/api/aawz-crm/crm-empresas/clientes',
}

export const gruposFamiliares = {
  manage: '/v3/api/aawz-crm/grupo-familiar',
  /**
   * Listagem agregada da tela `crm.grupos-familiares`: grupos + membros
   * visíveis + contagens de escopo em UMA requisição. É rota separada de
   * `manage` porque aquela serve o autocomplete dos modais e só precisa de
   * `id + nome` — mudar o shape dela quebraria um consumidor vivo.
   * @method GET Lista os grupos do escritório com membros visíveis
   */
  listagem: '/v3/api/aawz-crm/grupo-familiar/listagem',
  /**
   * Detalhe/edição de um grupo. É por aqui que o benchmark próprio do grupo
   * (`id_benchmark`) é gravado.
   * @method GET Detalhe do grupo
   * @method PUT Edita nome, descrição e/ou benchmark
   * @method DELETE Exclui o grupo (os vínculos caem em cascata)
   * @param {String} id UUID do grupo (`app_grupo_familiar.id`)
   */
  detalhe: (id) => `/v3/api/aawz-crm/grupo-familiar/${encodeURIComponent(id)}`,
  clientes: (id_cliente_app) =>
    id_cliente_app
      ? `/v3/api/aawz-crm/clientes/${id_cliente_app}/grupo-familiar`
      : '/v3/api/aawz-crm/grupo-familiar/clientes',
}

export const emails = {
  list: '/v3/api/aawz-crm/crm-conversas',
  sync: '/v3/api/aawz-crm/crm-conversas/sync',
  send: '/v3/api/aawz-crm/crm-conversas/send',
  attachment: '/v3/api/aawz-crm/crm-conversas/attachment',
  contadores: '/v3/api/aawz-crm/crm-conversas/contadores',
  markRead: '/v3/api/aawz-crm/crm-conversas/mark-read',
  markReadBatch: '/v3/api/aawz-crm/crm-conversas/mark-read-batch',
  trash: '/v3/api/aawz-crm/crm-conversas/trash',
  trashBatch: '/v3/api/aawz-crm/crm-conversas/trash-batch',
  restore: '/v3/api/aawz-crm/crm-conversas/restore',
  emailConfig: '/v3/api/aawz-crm/crm-conversas/email-config',
  labels: '/v3/api/aawz-crm/crm-conversas/labels',
  restoreBatch: '/v3/api/aawz-crm/crm-conversas/restore-batch',
}

export const googleIntegration = {
  /**
   * @method GET status da integração Google
   * @param {Boolean} detailed retorna scopes e email
   */
  status: '/v2/api/aawz_integracoes/status-autorizacao-integracao',
  /**
   * @method GET redireciona para autorização Google
   * @param {String} returnTo URL de retorno
   * @param {String} scopes escopos separados por vírgula
   */
  auth: (returnTo, scopes) =>
    `/v2/api/aawz_integracoes/auth2/authorization/google?return_to=${encodeURIComponent(
      returnTo
    )}&scopes=${scopes}`,
  /**
   * @method DELETE revoga integração Google
   */
  revoke: '/v2/api/aawz_integracoes/revoke-integracao?provedor=google',
}

export const microsoftIntegration = {
  /**
   * @method GET status da integração Microsoft
   * @param {Boolean} detailed retorna scopes e email
   */
  status: '/v2/api/aawz_integracoes/status-autorizacao-integracao',
  /**
   * @method POST/GET redireciona para autorização Microsoft
   * @param {String} returnTo URL de retorno
   * @param {String} scopes escopos selecionados separados por vírgula
   * (ex.: 'calendar,mail.read'). Apenas esses escopos são liberados; os
   * escopos base (User.Read + openid/email/profile/offline_access) são
   * sempre adicionados pelo backend.
   */
  auth: (returnTo, scopes) =>
    `/v2/api/aawz_integracoes/auth2/authorization/microsoft?return_to=${encodeURIComponent(
      returnTo
    )}&scopes=${scopes}`,
  /**
   * @method DELETE revoga integração Microsoft
   */
  revoke: '/v2/api/aawz_integracoes/revoke-integracao?provedor=microsoft',
}

export const externalIntegration = {
  google: {
    /**
     * @method GET
     * @param {String} urlReturn URL de retorno após a autorização
     * @param {String} provedor provedor de integração ('google' | 'microsoft')
     */
    emailAuth: (urlReturn, provedor = 'google') =>
      `/v2/api/aawz_integracoes/auth2/authorization/${provedor}?return_to=${encodeURIComponent(
        urlReturn
      )}`,
    /**
     * @method GET
     * Sem parâmetro provedor: retorna a lista de provedores autenticados.
     */
    emailStatus: `/v2/api/aawz_integracoes/status-autorizacao-integracao`,
  },
  /**
   * @method POST
   * @param {String}  to
   * @param {String}  subject
   * @param {String}  message
   * @param {String}  cc
   * @param {String}  bcc
   */
  sendEmail: `/v2/api/aawz_integracoes/email`,
  /**
   * @method POST
   * @param {Date} data_inicio  2025-10-30T21:30:00+00:00
   * @param {Date}  data_fim 2025-10-30T21:30:00+00:00
   * @param {String}  provedor google
   * @param {Array}  convidados ['email@email.com']
   * @param {String}  titulo Teste
   * @param {String}  descricao Teste
   */
  schedule: `/v2/api/aawz_integracoes/agenda/eventos`,
}

export const summary = {
  /**
   * @method GET — layout salvo do escritório pra entity_type (lead | cliente)
   * @method PUT — upsert do layout (somente gestor); body = { data: { layout: [...] } }
   * @method DELETE — reset (somente gestor); backend volta a entregar default
   */
  layout: (entityType) => `/v3/api/aawz-crm/summary-layout/${entityType}`,
  /**
   * @method GET — catalog completo (standard + custom + divider) pra paleta
   *
   * Query param opcional `scope=campos_obrigatorios` (só faz sentido com
   * `entityType='lead'`): resposta estendida com as 23 entradas da Ficha do
   * Cliente (`category: 'ficha_<grupo>'`, `handler: 'ficha'`, `available`).
   * SEM `scope`, a resposta é idêntica à atual — usar
   * `apiCrmSummary.carregarCatalogCamposObrigatorios` pro escopo estendido,
   * NUNCA escrever o resultado no cache `crm/summaryCatalog` (mesma chave
   * compartilhada por 5 consumidores que não sabem renderizar Ficha — ver
   * PLANNING.md §A.5 de `crm-campos-obrigatorios-ficha-cliente`).
   */
  fieldCatalog: (entityType) =>
    `/v3/api/aawz-crm/summary-field-catalog/${entityType}`,
  /**
   * @method GET — payload {layout, data} resolvido pro cliente específico
   *  (auth via APIPermissoes.check_professional_client_app)
   */
  data: (entityType, idClienteApp) =>
    `/v3/api/aawz-crm/summary/${entityType}/${idClienteApp}`,
}

export const overview = {
  /**
   * @method GET — layout resolvido pra scope (escritorio | profissional)
   * @method PUT — upsert do layout; body = { data: { layout: [...] } }
   * @method DELETE — reset do layout do scope
   */
  layout: (scope) => `/v3/api/aawz-crm/overview-layout/${scope}`,
  /**
   * @method GET — catálogo de blocos pequenos (paleta da Visão Geral)
   */
  blockCatalog: () => `/v3/api/aawz-crm/overview-block-catalog`,
}

export const camposPersonalizados = {
  /**
   * @method GET — lista todos os campos personalizados do escritório
   * @method POST — cria novo campo personalizado (somente gestor)
   */
  base: '/v3/api/aawz-crm/campos-personalizados',
  /**
   * @method PUT — edita campo personalizado pelo id (somente gestor)
   * @method DELETE — soft-delete pelo id (somente gestor)
   */
  byId: (id) => `/v3/api/aawz-crm/campos-personalizados/${id}`,
  /**
   * @method PUT — aplica lote de mudanças de ordem/cols (drag-and-drop)
   */
  reorder: '/v3/api/aawz-crm/campos-personalizados/reorder',
  /**
   * @method PUT — salva valores de campos personalizados no cliente.
   * Usado tanto pela aba do Lead quanto pela aba do Cliente (ambos
   * referenciam o mesmo id_cliente_app).
   */
  clienteValues: (idClienteApp) =>
    `/v3/api/aawz-crm/cliente/${idClienteApp}/custom-fields`,
}

export const marketingCliente = {
  /**
   * @method GET — dados de origem de marketing do cliente
   *  (fonte, campanha, medium, identificador, data_conversao). Todos os
   *  campos podem vir `null` (cliente sem dados) — isso é sucesso, não erro.
   * @method PUT — upsert; body = { data: JSON.stringify({ marketing: {...} }) }
   */
  byCliente: (idClienteApp) =>
    `/v3/api/aawz-crm/cliente/${idClienteApp}/marketing`,
}

export const officeConfig = {
  /**
   * @method GET — registro de escritorio_configuracao do escritório (gestor).
   * É por aqui que a tela de CRM LÊ as flags de bloqueio de personalização.
   * @method PUT — upsert parcial de colunas de configuração (ex: pl_min_cliente).
   * As flags de bloqueio do CRM NÃO são gravadas aqui: a escrita vai no
   * endpoint `bloqueioPersonalizacao`, que também purga as personalizações.
   */
  base: '/v2/api/office/config',
}

export const bloqueioPersonalizacao = {
  /**
   * @method PUT — grava a flag de bloqueio de personalização de UMA superfície
   * do CRM e, na transição desligado→ligado, apaga as personalizações pessoais
   * dos assessores daquela superfície (destrutivo, sem desfazer).
   * body = { data: { bloquear_personalizacao_visao_geral_crm?: bool,
   *                  bloquear_personalizacao_summary_crm?: bool } }
   * Envia-se apenas a chave que mudou.
   */
  base: '/v3/api/aawz-crm/bloqueio-personalizacao',
}

export const consolidador = {
  /**
   * @method GET
   */
  rentabilidade: (idClienteApp) =>
    `/v2/api/professional/portfolio/statistics/${idClienteApp}`,
  /**
   * @method POST
   * @param {Object} data { id_cliente: idClienteApp }
   * @returns {Object} { perfil, fracoes, client_allocation_status, _is_valid_client_allocation }
   */
  composicaoFracoes: '/v2/api/app/composicao/fracoes',
}

/**
 * Deck comercial da segunda reunião (spec-004).
 *
 * `id_cliente_app` vai no PATH nas três rotas, e não é detalhe de estilo: é o
 * que habilita o `decorator_check_client_app_access` do backend, que EXIGE o
 * parâmetro de rota e levanta `RuntimeError` sem ele
 * (`aawz_base/routes/util.py:988-1002`). Mandá-lo na query string derrubaria a
 * barreira de escritório dessas rotas.
 */
export const propostaR2 = {
  /**
   * @method POST — dispara a geração (assíncrona) e devolve o `hash`.
   * ★ O recurso declara `location='json'` nos dois argumentos, então a chamada
   * precisa de `{ json: true }` na connection — ver `apiCrmPropostaR2.gerar`.
   */
  gerar: (idClienteApp) =>
    `/v3/api/aawz-crm/clients/${idClienteApp}/proposta-r2/gerar`,
  /**
   * @method GET — polling do progresso. `value.step === -1` é concluído.
   */
  status: (idClienteApp, hash) =>
    `/v3/api/aawz-crm/clients/${idClienteApp}/proposta-r2/${hash}/status`,
  /**
   * @method GET — PDF em base64 sob `value.pdf` (nunca `value.base64`).
   */
  download: (idClienteApp, hash) =>
    `/v3/api/aawz-crm/clients/${idClienteApp}/proposta-r2/${hash}/download`,
}
